import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import {
	PostSandboxPromptResponse,
	updateSandboxPrompt,
	UpdateSandboxPromptProps
} from '@/services/sandboxPromptsService';
import type { HttpResponseError } from '@/services/service';

type UseUpdateSandboxPromptMutationProps = {
	onSuccess?: (data: PostSandboxPromptResponse) => void;
	onError?: (error: HttpResponseError) => void;
};

export const useUpdateSandboxPromptMutation = ({
	onSuccess,
	onError
}: UseUpdateSandboxPromptMutationProps) => {
	const { toast } = useToast();

	const queryClient = useQueryClient();

	return useMutation<unknown, HttpResponseError, UpdateSandboxPromptProps>({
		mutationKey: ['sandbox-prompt-update-mutation'],
		mutationFn: updateSandboxPrompt,
		onSuccess: ({ data }) => {
			queryClient.invalidateQueries(['sandbox-prompt-query']);
			onSuccess?.(data as PostSandboxPromptResponse);
		},
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			const errorMessage = {
				title: 'Something unexpected happened',
				description: 'Please try again or contact the support'
			};

			toast({
				...errorMessage,
				variant: 'error'
			});

			onError?.(error);
		}
	});
};
